module.exports = __webpack_public_path__ + "static/media/healthy-food.5091057c.png";